import { safeHTML } from '../../../../../../utils/safeHTML';
import CustomButton from '../../../../customButton/ui/main/CustomButton';
import { useTranslation } from '../../../../../../translations';
import content from '../../../constants/content';

const { modal } = content;

export default function Header({ status }) {
  const { title, text, button } = modal[status];
  const { t } = useTranslation();

  return (
    <>
      <h2 className={'drawing-result-modal__title'}>{safeHTML(t(title))}</h2>
      <h3 className={'drawing-result-modal__text'}>{safeHTML(t(text.standard))}</h3>
      {button && (
        <div className={'drawing-result-modal__buttons'}>
          <CustomButton {...button} />
        </div>
      )}
    </>
  );
}
